import React from "react";
import { buildCampaignActivityTimeline } from "../../utils/campaignActivityUtils";

const ICON_SIZE = 12;

/** activity timeline node */
const TimelineNode = ({ color = "#207C97" }) => (
  <svg
    width={ICON_SIZE}
    height={ICON_SIZE}
    viewBox="0 0 12 12"
    className="shrink-0"
    aria-hidden="true"
  >
    <circle cx="6" cy="6" r="5.25" fill="none" stroke={color} strokeWidth="1" />
    <circle cx="6" cy="6" r="2.75" fill={color} />
  </svg>
);

const CampaignActivityList = ({
  campaignActivities = [],
  contactName = "",
}) => {
  const timeline = buildCampaignActivityTimeline(
    campaignActivities,
    contactName,
  );

  if (!timeline.length) {
    return (
      <p className="text-xs font-normal text-gray-500 font-[Inter] text-center items-center justify-center flex h-full">
        No campaign activity yet. Add this contact to a campaign to get started.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {timeline.map((item, index) => {
        const isLast = index === timeline.length - 1;

        return (
          <div className="flex items-start gap-3.5" key={item.id}>
            <div
              className="mt-0.5 flex shrink-0 flex-col items-center"
              style={{ width: ICON_SIZE }}
            >
              <TimelineNode color="#207C97" />
              {!isLast && (
                <div className="mt-1 w-px min-h-[20px] flex-1 bg-gray-200" />
              )}
            </div>
            <div className="flex min-w-0 flex-col gap-0">
              <h6 className="text-[10.5px] font-medium text-gray-800 font-[Inter]">
                {item.title}
              </h6>
              <p className="text-[10.5px] font-normal text-gray-500 font-[Inter]">
                {item.hint || item.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CampaignActivityList;
